import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {List, SearchBar, Tabs, WingBlank, Flex, Toast, Button, WhiteSpace} from 'antd-mobile';
import InputNumber from '../../../components/InputNumber'
import _ from 'lodash'
import Mask from '../components/mask'
import Bubble from '../components/bubble'
import send from '../../../utils/send_init';
import auth from '../../../utils/auth';
const  TITLE = {
  feed: '饲料',
  medicine: '兽药',
  vaccine:'疫苗',
  semen:'精液'
};
let TYPES = ['feed', 'medicine', 'vaccine', 'semen'];
export default class Product extends Component {
  constructor (props) {
    super(props);
    this.state = {
      mask: true,
      autoFocus: 'feed0',
      tab: 0,
      tabs: [
        { title: '全部' },
        { title: '饲料' },
        { title: '兽药' },
        { title: '疫苗' },
        { title: '精液' }
      ],
      productSource: {
        feed:[],
        medicine:[],
        vaccine:[],
        semen:[]
      },
      list:{
        feed:[],
        medicine:[],
        vaccine:[],
        semen:[]
      },
      tooltips: [
        {
          message: '点击可以快速录入您的期初哦',
          position: {
            top: 0
          },
          visible: true
        }
      ]
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }
  doSearch = (v) => {
    const {tab,productSource} = this.state;
    console.log(tab,v,productSource);
    const listData = {};
    for (var key in productSource) {
      let data = productSource[key];
      listData[key] = data.filter(o => o.productName.indexOf(v)> -1)
    }
    this.setState({list: listData})
  };
  componentDidMount() {
    this.debounceData = _.debounce(v=>{
      this.doSearch(v)
    },500);
    this.setState({
      mask: auth.readCookie('ISFIRST')
    });
    this.getProduct()
  }
  getProduct = () => {
    Toast.loading('产品初始化中，请稍等',5);
    send({
      url: '/api/forward/ifarm/initInfo/init',
      method: 'get'
    }).then(res => {
      let product = auth.readCookie('product');
      const list = {
        feed:[],
        medicine:[],
        vaccine:[],
        semen:[],
        ...res.data.data,
        ...product
      };
      this.setState({
        list,
        productSource:list
      }, () => {
        Toast.hide();
      })
    }).catch(()=>{
      Toast.hide()
    })
  };
  setData = () => {
    auth.setCookie('product',this.state.list)
  };
  onFocus = (ref='feed0') => {
    // andt 的焦点
    ReactDOM.findDOMNode(this.refs[ref]).childNodes[0].children[1].children[0].focus()
  };
  renderList = (type) => {
    const {autoFocus, list} = this.state;
    return <List renderHeader={()=><div style={{fontSize: 18,padding: '5px 0'}}>{TITLE[type]}</div>}>
      {list[type].map((item,index) => {
        let pre = (item.calculateMethod === 'Q') ? 0 : 2;
        let max = (item.calculateMethod === 'Q') ? 9999999 : 9999999.99;
        return <div
          key={index}
          className={(this.state.mask && this.state.autoFocus === 'feed0' && index === 0) ? 'topShow w-10 text-right text-3' : 'text-right text-3'}
        >
          <InputNumber key={type + index}
                       autoFocus={autoFocus === (type + index) ? 'autofocus' : ''}
                       className={'text-right text-3'}
                       ref={type + index}
                       disabled={this.state.mask}
                       placeholder={'0'}
                       labelNumber={15}
                       precision={pre}
                       max={max}
                       value={item.num || ''}
                       extra={item.unitName}
                       onFocus={() => {
                         this.setState({
                           autoFocus: type + index
                         })
                       }}
                       onKeyUp={e => {
                         if(e.keyCode === 13) {
                           // 两种情况： 在同一个类型下，需要自动切换到下一个类型。
                           // 需要：1.在全部的时候，自动定位到下一个元素。
                           if (index < list[type].length - 1) {
                             // 在同一个type下
                             let id = type + (index + 1);
                             this.setState({
                               autoFocus: id,
                               mask: false
                             });
                             console.log(1);
                             this.onFocus(id)
                             // ReactDOM.findDOMNode(this.refs[id]).childNodes[0].children[1].children[0].focus()
                           } else {
                             // 切换到下一个有值的type
                             let autoFocus = '';
                             let arr = TYPES;
                             let index = arr.indexOf(type);
                             for (var i = (index + 1); i < arr.length; i++) {
                               var obj = list[arr[i]];
                               if (obj && (obj.length > 0)) {
                                 autoFocus = arr[i] + '0';
                                 break;
                               }
                             }
                             if (this.state.tab === 0) {
                               // 全部的时候，自动下一位
                               autoFocus && this.onFocus(autoFocus);
                             }
                           }
                         }
                       }
                       }
                       onChange={v => {
                         this.setState(state => {
                           item.num = v;
                           return state;
                         },() =>{
                           this.setData()
                         })
                       }}
          >
            <Flex>
              <span style={{fontSize: 12}}>{item.productName}</span>
              <div className={'bag'}>{item.unitName}</div>
            </Flex>
          </InputNumber>
        </div>

      })}
      {list[type].length === 0 && <div style={{padding: 15, textAlign: 'center'}}>无数据</div>}
    </List>
  };
  maskClick = async () => {
    const {list} = this.state;
    //  获取第一个焦点
    let autoFocus = '';
    let arr = TYPES;
    for (var i = 0; i < arr.length; i++) {
      var obj = list[arr[i]] || [];
      if (obj.length > 0) {
        autoFocus = arr[i] + '0';
        break;
      }
    }
    if (autoFocus) {
      //此时已经有返回值了
      this.setState({
        mask: false,
        autoFocus
      },()=>{
        this.onFocus(autoFocus); // input用doFocus来获取焦点，inputnumber 用onFocus
      });
    } else {
      //此时没有返回值
      this.setState({
        mask:false
      })
    }
  };
  render() {
    const {tabs,tab} = this.state;
    return (
      <div>
        <SearchBar placeholder={'点击搜索商品名称'}
            onChange={v => {
                     this.debounceData(v)
                   }}
        />
        <div style={{height: 44}}>
          <Tabs tabs={tabs}
              initialPage={tab}
              onTabClick={(tab, index) => {
                  this.setState({tab: index})
                }}
          />
        </div>
        <div className={'list-content'}>
          {
            tab===0 && (
              <div>
                {this.renderList('feed')}
                {this.renderList('medicine')}
                {this.renderList('vaccine')}
                {this.renderList('semen')}
              </div>
            )
          }
          {tab===1 && this.renderList('feed')}
          {tab===2 && this.renderList('medicine')}
          {tab===3 && this.renderList('vaccine')}
          {tab===4 && this.renderList('semen')}

          <WingBlank size="lg">
            <WhiteSpace size={'lg'}/>
            <Button type={'primary'}
                onClick={() => {
                      this.setData();
                      auth.setCookie('path','/createfarm/swine_add');
                      this.props.history.replace('/createfarm/swine_add')
                    }}
            >创建完成</Button>
            <WhiteSpace size={'lg'}/>
          </WingBlank>
        </div>



        <Mask visible={this.state.mask}
            onClick={() => {
              this.maskClick()
            }}
        >
        {
          this.state.tooltips.map((tips, index) => {
          return  <Bubble
              {...tips.position}
              visible={tips.visible.toString()}
              key={index}
                  >
          <div style={{height: 80,width: '80vw', margin: '200px auto'}}>
            {this.state.mask && tips.message}
          </div>
          </Bubble>
          })
        }
        </Mask>
      </div>
    )
  }
}
